import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCyberAngle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M15.997 12a.5.5 0 0 1 .38.175l6.003 7a.5.5 0 0 1-.76.65l-5.623-6.557-5.617 6.557a.5.5 0 1 1-.76-.65l5.997-7a.5.5 0 0 1 .38-.175",
		clipRule: "evenodd"
	})
});
export default SvgCyberAngle;
